<template>
  <!-- 消息中心-消息列表 -->
  <div class="wx-message">
    <div class="msg-header">
      <div class="box">
        <ul class="nav-bar">
          <li
            class="item"
            :class="{ active: isActive === 0 }"
            @click="onActive(0)"
          >
            <t-badge :count="numVal" :offset="[-3, 0]">{{
              $t("MessageList.NewMessage")
            }}</t-badge>
          </li>
          <li
            class="item"
            :class="{ active: isActive === 1 }"
            @click="onActive(1)"
          >
            {{ $t("MessageList.MessageHistory") }}
          </li>
        </ul>
        <p class="all-btn" @click="onAllReadMessage">
          {{ $t("MessageList.One-clickRead") }}
        </p>
      </div>
      <div class="bottor-border"></div>
    </div>
    <!-- 消息列表 -->
    <div class="message-list">
      <t-list
        class="list"
        v-if="listRef.length > 0"
        style="height: 437px"
        :scroll="{ type: 'virtual' }"
        ><t-list-item v-for="(item, index) in listRef" :key="index">
          <t-list-item-meta
            :class="{ 'img-bg': item.businessType === 4 }"
            :image="
              item.businessType === 1
                ? imageUrlXT
                : item.businessType === 2
                ? imageUrlZB
                : item.businessType === 3
                ? imageUrlJH
                : imageUrlJY
            "
            :title="item.title + '：' + item.content"
            :description="item.createTime"
            @click="onRead(item)"
          />
          <template
            #action
            v-if="item.businessType === 4 && item.readFlag === 0 && item.operateType !== 0"
          >
            <div class="btn" @click.stop="onReadMessage(item, '1')">
              {{ $t("MessageList.Consent") }}
            </div>
            <div class="btn" @click.stop="onReadMessage(item, '2')">
              {{ $t("MessageList.Refuse") }}
            </div>
          </template>
          <template
            #action
            v-if="item.businessType === 4 && item.readFlag === 1 && item.operateType !== 0"
          >
            <div class="btn-gray" v-if="item.operate === '1'">
              {{ $t("MessageList.Consent") }}
            </div>
            <div class="btn-gray" v-if="item.operate === '2'">
              {{ $t("MessageList.Refuse") }}
            </div>
          </template>
        </t-list-item></t-list
      >
      <div class="no-content" v-else>
        <img class="default-graph" src="@/assets/dataNull.png" alt="" />
        <p class="no-text">{{ $t("MessageList.NoNotice") }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import Cookies from "js-cookie";
import { ref, reactive, defineEmits } from "vue";
import { useRouter } from "vue-router";
import { debounce, throttle } from "lodash";
import {
  baseNoticeByPage,
  baseReadNoticeCount,
  baseReadNotice,
  baseNoticeReadNotice,
  teachingResearchClassroomPage,
  teachingResearchClassroomDenyUserApply,
} from "@/api/teaching.js";

const emit = defineEmits(["onNumVal"]);

const userInfo = Cookies.get("userInfo");
const userId = JSON.parse(userInfo).userId;

const router = useRouter();

const pageDate = reactive({
  pfType: 1, //平台id：1智慧课堂
  // businessType: 1, //业务类型：1系统通知，2直播通知，3互动通知，4教研通知
  readFlag: 0, //读取标识：0未读，1已读，默认0
  // pageNum: 1, //页码(默认1,-1查询全部)
  // pageSize: 10, //每页条数(默认10,-1查询全部)
  queryName: "", //模糊查询字段
});
const imageUrlXT = require("@/assets/Front/message/message-img-xt.svg");
const imageUrlZB = require("@/assets/Front/message/message-img-zb.svg");
const imageUrlJH = require("@/assets/Front/message/message-img-jh.svg");
const imageUrlJY = require("@/assets/Front/message/message-img-jy.svg");
const listRef = ref([]);

const getList = debounce(async () => {
  const res = await baseNoticeByPage(pageDate);
  if (res.code === 1) {
    listRef.value = res.data.list;
    // console.log("消息列表数据", res.data);
    if (pageDate.readFlag === 0) {
      getNumber();
    }
  }
}, 500);

const numVal = ref(0);
const getNumber = async () => {
  // 获取我的未读消息个数
  const res = await baseReadNoticeCount({
    pfType: pageDate.pfType,
    readFlag: 0,
  });
  if (res.code === 1) {
    numVal.value = res.data;
    emit("onNumVal", res.data);
    // console.log("未读消息个数", res.data);
  }
};

//初始化
getList();

const isActive = ref(0);
const onActive = (val) => {
  pageDate.readFlag = val;
  isActive.value = val;
  getList();
};

// 一键已读
const onAllReadMessage = debounce(async () => {
  const res = await baseReadNotice();
  if (res.code === 1) {
    getList();
  }
}, 500);

// 读取消息（同意和拒绝）
const onReadMessage = debounce(async (val, operate) => {
  if (val.readFlag === 0) {
    const res = await baseNoticeReadNotice({
      id: val.id,
      operate: operate,
    });
    if (res.code === 1) {
      getList();
    }

    if (val.businessType === 1 && val.operateType === 1) {
      // operateType 操作类型:0无操作，1跳转，2选择
      let href = "";
      href =
        window.location.protocol +
        "//" +
        window.location.host +
        "/hztgl" +
        "/group/SchoolExamine";
      window.open(href); // 跳转中台-注册审批
    }

    if (val.businessType === 4 && operate === "1") {
      console.log("通用");
      const res = await teachingResearchClassroomPage(userId, {
        id: val.businessId,
        userId: userId,
      });
    }
    if (val.businessType === 4 && operate === "2") {
      const res = await teachingResearchClassroomDenyUserApply(userId, {
        id: val.businessId,
        userId: userId,
      });
    }
  }
}, 500);

// 读消息
const onRead = (val) => {
  if (val.businessType !== 4) {
    onReadMessage(val, "1");
  } else {
    if (val.operateType === 1) {
      router.push({
        path: "/wenxiang_Backstage/TeachingAndResearch",
      });
    }
  }
};

defineExpose({ getList });
</script>

<style lang="less" scoped>
.wx-message {
  width: 400px;
  height: 511px;

  .msg-header {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;

    .box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .nav-bar {
        margin-left: -20px;
        display: flex;

        .item {
          color: #00000066;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 64px;
          cursor: pointer;
          height: 64px;
          margin: 0 20px;

          :deep(.t-badge) {
            color: #00000066;
            font-size: 16px;
            font-weight: 600;
          }
        }

        .active {
          color: #000000e5;
          position: relative;

          :deep(.t-badge) {
            color: #000000e5;
          }

          &::after {
            content: "";
            display: inline-table;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 1.6px;
            background-color: #366ef4;
          }
        }
      }

      .all-btn {
        color: #366ef4;
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 64px;
        cursor: pointer;
      }
    }

    .bottor-border {
      width: 100%;
      height: 1px;
      background-color: #e7e8eb;
    }
  }

  .message-list {
    width: 100%;
    height: 437px;
    margin-top: 10px;
    position: relative;

    .list {
      :deep(.t-list-item__meta-avatar) {
        width: 43px;
        height: 43px;
        border-radius: 7px;
        background: linear-gradient(180deg, #5dde7a 0%, #46bd44 100%);
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 25px;
        }
      }

      :deep(.t-list-item__meta-content) {
        width: 301px;
        border-bottom: 1px solid #e7e8eb;

        .t-list-item__meta-title {
          color: #000000e5;
          font-size: 14px;
          line-height: 22px;
          margin: 0;
        }

        .t-list-item__meta-description {
          color: #00000099;
          font-size: 14px;
          line-height: 22px;
          width: 60%;
          padding-bottom: 5px;
        }
      }

      :deep(.t-list-item) {
        .t-list-item-main {
          position: relative;

          .img-bg {
            .t-list-item__meta-avatar {
              background: linear-gradient(180deg, #517ded 0%, #4b5cf1 100%);
            }
          }

          .t-list-item__action {
            display: flex;
            position: absolute;
            right: 0;
            bottom: 5px;

            .btn {
              cursor: pointer;
              color: #366ef4;
              font-size: 14px;
              text-align: center;
              line-height: 32px;
              width: 60px;
              height: 32px;
              border-radius: 8px;

              &:hover {
                color: white;
                background: radial-gradient(
                  302.16% 141.42% at 0% 100%,
                  #36a4f4 0%,
                  #366ef4 52.98%,
                  #0163f6 100%
                );
              }
            }

            .btn-gray {
              cursor: pointer;
              color: white;
              font-size: 14px;
              text-align: center;
              line-height: 32px;
              width: 60px;
              height: 32px;
              border-radius: 8px;
              background-color: #00000066;
            }
          }
        }
      }
    }

    .no-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .no-text {
        color: #9499a0;
        font-family: "PingFang SC";
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 100%; /* 13px */
        margin-top: -20px;
      }
    }
  }
}
</style>
